var popup = (function() {
  var $overlayEl = $('#popup-overlay')
  var $popupElShow = $('.popup-content.show-at-start')
  var $popupEl = $('.popup-content')
  var $closeBut = $popupEl.find('.close')
    /* Remove */
  if ($popupElShow.length) {
    fadeIn()
  }

  $overlayEl.click(function() {
    fadeOut()
  })
  $closeBut.click(function() {
    fadeOut()
  })

  function fadeIn(arg) {
    if (arg) {
      var item = $popupEl.filter(arg)
      if (item.length) {
        $overlayEl.fadeIn()
        item.fadeIn()
      }
    } else {
      $overlayEl.fadeIn()
      $popupEl.fadeIn()
    }
  }

  function fadeOut() {
    $overlayEl.fadeOut()
    $popupEl.fadeOut()
  }

  return {
    fadeIn: fadeIn,
    fadeOut: fadeOut
  }
})()


var bindPopupOpeners = window.bindPopupOpeners = function () {

$('.popup-opener').on('click', function(e) {
  e.preventDefault()
  if (!$(this).data('target')) {
    console.log('Error loading target on popup-opener.')
  }

  const hiddenEl = $(this).closest('.hidden-value')
  let hiddenVal = false
  if (hiddenEl && hiddenEl.length > 0) {
    hiddenVal = hiddenEl.data('hidden-value')
  }

  // console.log(hiddenVal);
  var target = $(this).data('target')
  // console.log("target", target)
  // console.log($('#' + target).find('input.hidden-value'), '#' + target);
  $('#' + target).find('input.hidden-value').val(hiddenVal)
  popup.fadeIn('#' + target)
})

}

bindPopupOpeners()



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/popups.js